import HomeDomains from './Home.domains.vue'
import DomainsEdit from './Home.domains-edit.vue'
import Home from './Home.domain.vue'

export default { 
    HomeDomains, DomainsEdit, Home
}